// Local media URL resolver — single source of truth for product imagery.
// Product.images[] stores ONLY relative local paths (/uploads/YYYY-MM/*.webp)
// plus legacy/external https:// URLs (paste-URL fallback, kept so unmigrated
// data keeps working). Relative paths resolve against the backend base URL
// (VITE_API_URL); absolute URLs pass through untouched.
import { API_BASE } from '../config';

export function resolveMediaUrl(src) {
  if (typeof src !== 'string' || !src) return src;
  if (src.startsWith('/uploads/')) return `${API_BASE}${src}`;
  return src;
}
